// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nfwK2fX8v452m536HBY+tQ=="};